/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BillingInfo} from '../models/BillingInfo';
import type {Error} from '../models/Error';

export interface GetLicenseBilling$Request {
    licenseId: number;
}

export interface GetLicenseBilling$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseBillingRequest = createAction<PayloadData<void, GetLicenseBilling$Request>>('GET_LICENSE_BILLING__GET_LICENSE_BILLING__REQUEST');
export const getLicenseBillingSuccess = createAction<PayloadData<BillingInfo, GetLicenseBilling$Request>>('GET_LICENSE_BILLING__GET_LICENSE_BILLING__SUCCESS');
export const getLicenseBillingFailure = createAction<PayloadData<Error, GetLicenseBilling$Request, true>>('GET_LICENSE_BILLING__GET_LICENSE_BILLING__FAILURE');

export const getLicenseBillingActions = [
    getLicenseBillingRequest,
    getLicenseBillingSuccess,
    getLicenseBillingFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseBilling = (meta: GetLicenseBilling$Request, config?: GetLicenseBilling$Config) => {
    return {
        CALL_API: {
            types: getLicenseBillingActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}/billing`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

